import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { BreathAPIs } from '../APIs/BreathAPIs.js';
import './Payment.css';

import { toast, ToastContainer } from 'react-toastify';
import StripePayment from '../StripePayment/StripePayment.js';
import { useNavigate } from 'react-router-dom';
import PaymentStyle from './PaymentStyle.js';




const Payment = (props) => {

    const navigate = useNavigate();

    const handleRedirect = () => {
        setTimeout(() => {
            navigate('/');
        }, 5000)

    };


    return (
        <div className="container mb-5 mb-md-6 mt-5">
            <ToastContainer />

            <div className="row">
                <div className="col-md-6 d-none d-md-block">
                    <h2>Make a Payment</h2>
                    <PaymentStyle />
                </div>

                <div className="col-12 col-md-6 z-0">
                    <StripePayment setWalletRechargeModal={handleRedirect} amountToAdd={10} />
                </div>
            </div>
        </div>

    );
}


Payment.propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
}
const mapStateToProps = state => ({
    firstName: state.auth && state.auth.user ? state.auth.user.firstName : null,
    lastName: state.auth && state.auth.user ? state.auth.user.lastName : null,
})

export default connect(mapStateToProps, {})(Payment);